module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/boxes-a44e3d962bdfb4897c8f4edb4112218f.png";